/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementGtagForDomainEnvOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementGtagForDomainEnvOptions(value) {
    if (!('Auth' in value) || value['Auth'] === undefined)
        return false;
    if (!('Preview' in value) || value['Preview'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsAdvertisementGtagForDomainEnvOptionsFromJSON(json) {
    return FxIdDomainSettingsAdvertisementGtagForDomainEnvOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementGtagForDomainEnvOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Auth': json['Auth'],
        'Preview': json['Preview'],
    };
}
export function FxIdDomainSettingsAdvertisementGtagForDomainEnvOptionsToJSON(json) {
    return FxIdDomainSettingsAdvertisementGtagForDomainEnvOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementGtagForDomainEnvOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Auth': value['Auth'],
        'Preview': value['Preview'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementGtagForDomainEnvOptions.js.map